import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getGaMeasurementId } from "../utils/config";

/**
 * Sends GA4 virtual pageviews on client-side route changes.
 * Relies on the env-gated gtag bootstrap in public/index.html.
 */
export default function GoogleAnalyticsRouteTracker() {
  const location = useLocation();
  const measurementId = getGaMeasurementId();

  useEffect(() => {
    if (!measurementId || typeof window.gtag !== "function") {
      return;
    }
    const pagePath = `${location.pathname}${location.search}`;
    window.gtag("config", measurementId, { page_path: pagePath });
  }, [location.pathname, location.search, measurementId]);

  return null;
}
